import React from 'react';
import { NavLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import {  Grid,  } from '@material-ui/core';
import { Link,  useLocation } from 'react-router-dom';

import LanguageSelector from '../LanguageSelector/LanguageSelector';
const useStyles = makeStyles((theme) => ({
  selected: {
    '&:after': {
      position: 'absolute',
      content: '""',
      height: '5px',
      backgroundColor: theme.palette.primary.main,
      left: '0',
      bottom: '-15px',
      width: '100%',
    },
  },
  selectedPff: {
    '&:after': {
      position: 'absolute',
      content: '""',
      height: '5px',
      backgroundColor: '#e37a00',
      left: '0',
      bottom: '-15px',
      width: '100%',
    },
  },
}));

function MenuItem({
  exact,
  to,
  openCloseCallback = () => {},
  labelLink,
  target = '_self',
  isPff,
}) {
  const classes = useStyles();
  const location = useLocation();

  const path = location.pathname;

  return (
    <>
    <li>
      <NavLink
        exact={exact}
        target={target}
        to={to}
        activeClassName={!isPff ? classes.selected : classes.selectedPff}
        onMouseEnter={() => {
          openCloseCallback(true);
        }}
        onClick={() => {
          openCloseCallback(false);
        }}
        onMouseLeave={() => {
          openCloseCallback(false);
        }}
        style={{      color: "#2D3741",
          
            fontWeight: 500,
            color: '#2D3741',
            fontSize: '16px',
            fontFamily: 'Druk Wide Medium',
            textTransform: "capitalize"
          
        }}
      >
        {labelLink}
      </NavLink>
    </li>
                  </>
  );
}

MenuItem.propTypes = {
  labelLink: PropTypes.string,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  openCloseCallback: PropTypes.func,
  exact: PropTypes.bool,
};

export default MenuItem;
